import { ICommonInputProps } from "../../../shared/commonTypes/commonTypes";
import { IOptions } from "../../../shared/ui/Input/Input";


export enum PasswordInputKeys {
	NEW_PASSWORD = 'newPassword',
	REPEAT_NEW_PASSWORD = 'repeatNewPassword',
}

export type TChangePasswordStore = Record<PasswordInputKeys, ICommonInputProps>;

export interface IChangePasswordInputs {
	label: string;
	inputName: keyof TChangePasswordStore
	options: IOptions[];
}

export interface IChangePasswordRequest {
	uid: string;
  	token: string;
	new_password: string;
}